import React, { Component } from "react";
import "../../src/css/floating-button.css";
import { Link } from "@reach/router";

class FloatingButton extends Component {
  render() {
    return (
      <Link to={this.props.url}>
        <div className="floating-wrapper">
          <div className="floating-button">
            <div className="floating-inner"></div>
          </div>
        </div>
      </Link>
    );
  }
}

export default FloatingButton;
